import { IAreaCodeInitialState } from "../../../types/master/areaCodeInterface";
import { AreaCodeActionTypes, AreaCodeActions } from "../../actionTypes/master/areaCodeActionTypes";

const initialState: IAreaCodeInitialState = {
  areaCodeList: [],
  areaCodeData: {
    id: 0,
    area_code: "",
    area_name: "",
    hub_code: 0,
    created_by: 0,
    state: [
      {
        id: 0,
        state_name: "",
        slug: "",
        createdAt: "",
        updatedAt: "",
        district: [
          {
            id: 0,
            district_name: "",
          },
        ],
      },
    ],
  },
  areaCodeListPageCount: 0,
};

export default function areaCodeReducer(state = initialState, action: AreaCodeActionTypes): IAreaCodeInitialState {
  switch (action.type) {
    case AreaCodeActions.SET_AREA_CODE_LIST:
      return {
        ...state,
        areaCodeList: action.payload,
      };

    case AreaCodeActions.SET_AREA_CODE_LIST_PAGE_COUNT:
      return {
        ...state,
        areaCodeListPageCount: action.payload,
      };

    case AreaCodeActions.SET_AREA_CODE_DATA_BY_ID:
      return {
        ...state,
        areaCodeData: action.payload,
      };

    default:
      return state;
  }
}
